import { ImageDropPlugin } from './ImageDropPlugin';
import { ImageResolverPlugin } from './ImageResolverPlugin';

/** Resolves stored image ids on load and uploads dropped or pasted images. */
export const ImagesPlugin = () => (
  <>
    <ImageResolverPlugin />
    <ImageDropPlugin />
  </>
);
